export const CITIES = 'cities'
export const CITY = 'city'
export const CITY_COLLECTION_SITES = 'city_collection_sites'
